import { Directive, ElementRef, Input, OnInit } from '@angular/core';

import { MsalService } from 'msal';
import { AuthenticationService } from 'core/authentication.service';

@Directive({
  selector: '[appDisabledIndividualElement]'
})
export class DisabledIndividualElementDirective implements OnInit {
  @Input() appDisabledIndividualElement;
  constructor(private eleRef: ElementRef, private msalService: MsalService, private _auth: AuthenticationService) { }
  disableClass() {
    this.eleRef.nativeElement.style.cursor = 'not-allowed';
    this.eleRef.nativeElement.style.pointerEvents = 'auto';
    this.eleRef.nativeElement.style.backgroundColor = '#f7f7f7';
  };
  enableClass() {
    this.eleRef.nativeElement.style.cursor = 'pointer';
    this.eleRef.nativeElement.style.pointerEvents = 'auto';
    this.eleRef.nativeElement.style.backgroundColor = 'none';
  };
  ngOnInit() {
    let view = true;
    let edit = false;
    let roles = this._auth.getUserRoles(this.msalService);
    roles.forEach((value, key) => {
      if (this.appDisabledIndividualElement == value) {
        edit = true;
      }
    });
    edit ? this.enableClass() : this.disableClass();
  }
}
